import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import Button from "components/button/Button";
import { FaSave, FaTrash } from "react-icons/fa";

interface Props {
  open: boolean;
  onRestore: () => void;
  onDiscard: () => void;
}

export default function DraftRecoveryModal({
  open,
  onRestore,
  onDiscard,
}: Props) {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-md"
          onClick={onDiscard}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="mx-4 w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl dark:bg-gray-800"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
                <FaSave className="h-8 w-8 text-amber-600 dark:text-amber-400" />
              </div>

              <h3 className="mb-2 text-xl font-semibold text-gray-900 dark:text-white">
                {t("draft.recoveryTitle")}
              </h3>

              <p className="mb-4 text-gray-600 dark:text-gray-300">
                {t("draft.recoveryMessage")}
              </p>

              <div className="flex gap-3">
                <Button
                  onClick={onDiscard}
                  variant="error"
                  size="sm"
                  className="flex-1"
                  startIcon={<FaTrash size={14} />}
                >
                  {t("draft.discard")}
                </Button>

                <Button
                  onClick={onRestore}
                  variant="primary"
                  size="sm"
                  className="flex-1"
                  startIcon={<FaSave size={14} />}
                >
                  {t("draft.restore")}
                </Button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
